import { GetterTree } from "vuex";
import { DeviceState } from "./state";
import { defineVuexName, MODULES } from "@/store/utils";

const getters: GetterTree<DeviceState, any> = {
  [defineVuexName(MODULES.DEVICE.GETTERS.IS_SETTING_DEVICE_MODAL_OPEN)](s: DeviceState) {
    return s.isSettingDeviceModalOpen;
  },
  [defineVuexName(MODULES.DEVICE.GETTERS.SETTING_DEVICE_MODAL_VIEW)](s: DeviceState) {
    return s.settingDeviceModalView;
  },
};

export default getters;
